export default __webpack_public_path__ + "7722451a8c88b6100185c11697683609.ttf";